<template>
    <div class="fillin">
        <div>
            <textarea v-model="item" placeholder="Type here"></textarea>
        </div>

        <button @click="save">I'm done</button>
    </div>
</template>

<!-- <style scoped>
    input {
        font-size: large;
        margin: 10px;
        padding: 10px;
        width: 85vw;
    }

    .fillin {
        background-color: white;
        border-color: #BAB8B6;
        border: 3px solid #BAB8B6;
        margin: 10px 30px 10px 30px;
        padding: 30px 30px;
        border-radius: 50px 50px 50px 50px;
        text-align: start;
        animation-name: example;
        animation-duration: 1s;
        animation-timing-function: ease-in-out;
        position: relative;
    }

    button {
        background-color: #DDE4DE;
        font-size: medium;
        border: 3px solid #AFCAC4;
        margin: 10px;
        padding: 20px;
        border-radius: 50px 50px 50px 50px;
        box-shadow: 5px 5px 10px #CCCAC6;
        outline: 0 none;
    }
</style> -->

<script>
import { Message } from '@/bot-engine.es5.js';

export default {
    name: 'Fillin',
    props: {
        message: {
            type: Message
        }
    },
    data() {
        return {
          item: ""
        }
    },
    methods: {
        save() {
            let key = this.message.options.varName
            
            this.$emit('input', {key: key, value: this.item});
        },
        cancel() {
            this.$emit('input', {key: key, value: ""});
        }
    }
}
</script>

<style>
  @keyframes fromleft {
    0%   {left:-200px; top:0px;}
    75%  {left:40px; top:0px;}
    100% {left:0px; top:0px;}
  }

  .fillin {
    animation-name: fromleft;
    animation-duration: 1s;

    animation-timing-function: ease-in-out;
    position: relative;
  }
</style>